<template>
    <div class="school-admin-video-material">
        <VideoInstruction :headTitle="$t('videoInstructionsForAdmin')" :role="'ROLE_ADMIN'"/>
    </div>
</template>

<script>
import VideoInstruction from '@/components/video-instruction/VideoInstruction'
export default {
  components: {
    VideoInstruction
  }
}
</script>
